'use client';

/**
 * Expandable Section Component
 *
 * Renders a simple collapsible section.
 */

import classNames from 'classnames';
import React, { useState } from 'react';

import type { ExpandableConfig } from '../types';

interface ExpandableSectionProps {
  config: ExpandableConfig;
  className?: string;
}

export const ExpandableSection: React.FC<ExpandableSectionProps> = ({ config, className }) => {
  const [isExpanded, setIsExpanded] = useState(config.defaultOpen);

  const toggle = () => setIsExpanded((prev) => !prev);

  return (
    <div className={classNames('expandable-section', className)}>
      <button
        onClick={toggle}
        className="flex items-center justify-between w-full py-3 text-left"
        aria-expanded={isExpanded}
      >
        <div className="flex-1" dangerouslySetInnerHTML={{ __html: config.triggerHtml }} />

        <svg
          width="16"
          height="16"
          className={classNames('transition-transform duration-200', {
            'rotate-180': isExpanded,
          })}
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M4 6l4 4 4-4"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isExpanded && (
        <div className="expandable-content pb-4" dangerouslySetInnerHTML={{ __html: config.contentHtml }} />
      )}
    </div>
  );
};
